import {
    FETCH_GOLF_SCORECARDS_SUMMARY,
    FETCH_GOLF_SCORECARDS_SUMMARY_SUCCESS,
    FETCH_GOLF_SCORECARDS_SUMMARY_FAIL,
    REMOVE_GOLF_SCORECARD_SUMMARY,
    DELETE_GOLF_SCORECARD_SUCCESS
} from 'actions/golfScorecardActions.js';

// Used for updates/saves
export const NETWORKING_STATUSES = {
    FAIL: 'FAIL',
    SUCCESS: 'SUCCESS',
    FETCHING: 'FETCHING'
};

const INITIAL_STATE = {
    golfScorecardSummaries: {},
    networkingStatus: NETWORKING_STATUSES.SUCCESS
};

const fetchScorecardSummariesSuccess = (state, action) => {
    return {
        golfScorecardSummaries: {
            ...state.golfScorecardSummaries,
            [action.connectionDisplayName || action.displayName]: action.scorecardSummaries
        },
        networkingStatus: NETWORKING_STATUSES.SUCCESS
    };
};

const fetchScorecardSummariesStart = (state, action) => {
    return {
        golfScorecardSummaries: {
            ...state.golfScorecardSummaries
        },
        networkingStatus: NETWORKING_STATUSES.FETCHING
    };
};

const fetchScorecardSummariesFail = (state, action) => {
    return {
        golfScorecardSummaries: {
            ...state.golfScorecardSummaries
        },
        networkingStatus: NETWORKING_STATUSES.FAIL
    };
};

const removeScorecardSummaryFromStore = (state, action) => {
    var summaries = {};
    let scorecardId = parseInt(action.scorecardId, 10);
    for (var displayName of Object.keys(state.golfScorecardSummaries)) {
        summaries[displayName] = state.golfScorecardSummaries[displayName].filter(
            (summary) => summary.id !== scorecardId
        );
    }
    return {
        golfScorecardSummaries: {
            ...summaries
        },
        networkingStatus: NETWORKING_STATUSES.SUCCESS
    };
};

const handlers = {
    [FETCH_GOLF_SCORECARDS_SUMMARY]: fetchScorecardSummariesStart,
    [FETCH_GOLF_SCORECARDS_SUMMARY_SUCCESS]: fetchScorecardSummariesSuccess,
    [FETCH_GOLF_SCORECARDS_SUMMARY_FAIL]: fetchScorecardSummariesFail,
    [REMOVE_GOLF_SCORECARD_SUMMARY]: removeScorecardSummaryFromStore,
    [DELETE_GOLF_SCORECARD_SUCCESS]: removeScorecardSummaryFromStore
};

export default function golfScorecardSummary(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// Actions
export function fetchScorecardSummaries(displayName, connectionDisplayName, userLocale, evictCache) {
    return {
        type: FETCH_GOLF_SCORECARDS_SUMMARY,
        connectionDisplayName: connectionDisplayName,
        displayName: displayName,
        userLocale: userLocale,
        meta: {
            cacheTime: evictCache ? null : 10000
        }
    };
}

export function removeScorecardSummary(scorecardId) {
    // remove a scorecard summary from the store
    // this is a stop gap solution until scorecard page is in React
    return {
        type: REMOVE_GOLF_SCORECARD_SUMMARY,
        scorecardId: scorecardId
    };
}

// Getters
export const getGolfScorecardSummaries = (state, displayName) => {
    const golfScorecardSummaries = state.golfScorecardSummary.golfScorecardSummaries[displayName];
    return golfScorecardSummaries;
};

export const getGolfScorecardSummaryNetworkStatus = (state) => {
    return state.golfScorecardSummary.networkingStatus;
};
